/* Tha Layover footer: mobile accordion */
(function () {
  var mq = matchMedia('(max-width: 749px)');
  function sync() { document.querySelectorAll('[data-tl-acc]').forEach(function (d) { d.open = !mq.matches; }); }
  sync();
  if (window.TLFooter) return;
  window.TLFooter = true;
  mq.addEventListener('change', sync);
  document.addEventListener('shopify:section:load', sync);
  document.addEventListener('click', function (e) {
    if (e.target.closest('.tl-footer-column > summary') && !mq.matches) e.preventDefault();
  });
})();
